export const COLORS = {
  PRIMARY: '#7144C0',
  SECONDARY: '#E5A4CB',
  BLACK: '#2F242C',
  WHITE: '#F2F7F2',
  PROGRESS: '#01A7C2',
  PROGRESS_LIGHT: '#92D7DF',
  LIKE: '#28A228',
  DISLIKE: '#F22613',
  LIGHT_GREY: '#D9D9D9',
  WARNING: '#B8860B',
  ADMIN_PRIMARY: '#186DB6',
  ADMIN_SECONDARY: '#FFA500',
}